import { InvalidDroppedFile, ValidDroppedFile } from "./types";
import { validDimensions } from "./constants";

export const validateFileType = (file: File, isVideoCampaign: boolean) => {
  const fileType = file.type.split("/")[0];
  const mediaType = isVideoCampaign ? "video" : "image";
  return fileType === mediaType;
};

export const validateImageDimension = (dimension: string) => {
  return validDimensions.includes(dimension);
};

// export const handleFileLoad = (
//   file: File,
//   validFiles: ValidDroppedFile[],
//   invalidFiles: InvalidDroppedFile[],
//   resolve: (value?: void | PromiseLike<void> | undefined) => void,
// ) => {
//   const fileType = file.type.split("/")[0];

//   if (fileType === "image") {
//     const img = new Image();
//     img.src = URL.createObjectURL(file);
//     img.addEventListener("load", () => {
//       const width = img.width.toString();
//       const height = img.height.toString();
//       const dimension = `${width.trim()}x${height.trim()}`;
//       // validate image dimension
//       if (validateImageDimension(dimension)) {
//         validFiles.push({
//           width: +dimension.split("x")[0],
//           height: +dimension.split("x")[1],
//           file,
//           fileType: "image",
//         });
//       } else {
//         invalidFiles.push({
//           file,
//           width: +dimension.split("x")[0],
//           height: +dimension.split("x")[1],
//           errorMessage: `File with the wrong dimension: ${file.name}, ${dimension}.`,
//           fileType: "image",
//         });
//       }
//       resolve();
//     });
//   }

//   if (fileType === "video") {
//     const video = document.createElement("video");
//     video.src = URL.createObjectURL(file);

//     video.addEventListener("loadedmetadata", () => {
//       // const width = video.videoWidth;
//       // const height = video.videoHeight;

//       validFiles.push({
//         width: null,
//         height: null,
//         file,
//         fileType: "video",
//         duration: 60,
//       });
//       resolve();
//     });
//   }
// };

export const handleImageLoad = (
  file: File,
  validFiles: ValidDroppedFile[],
  invalidFiles: InvalidDroppedFile[],
  resolve: (value?: void | PromiseLike<void> | undefined) => void,
  isVideoCampaign: boolean,
) => {
  const img = new Image();
  img.src = URL.createObjectURL(file);
  img.addEventListener("load", () => {
    const width = img.width.toString();
    const height = img.height.toString();
    const dimension = `${width.trim()}x${height.trim()}`;
    const fileSize = file.size;
    const sizeLimit = isVideoCampaign ? 250000000 : 800000;
    const isSizeValid = fileSize < sizeLimit;

    if (validateImageDimension(dimension) && isSizeValid) {
      validFiles.push({
        width: +dimension.split("x")[0],
        height: +dimension.split("x")[1],
        file,
        fileType: "image",
      });
    } else {
      const errorMessage = isSizeValid
        ? `File with the wrong dimension: ${file.name}, ${dimension}.`
        : `File with the wrong size: ${file.name}, ${fileSize} bytes.`;

      invalidFiles.push({
        file,
        width: +dimension.split("x")[0],
        height: +dimension.split("x")[1],
        errorMessage,
        fileType: "image",
      });
    }
    resolve();
  });
};

export const handleVideoLoad = (
  file: File,
  validFiles: ValidDroppedFile[],
  resolve: (value?: void | PromiseLike<void> | undefined) => void,
) => {
  const video = document.createElement("video");
  video.src = URL.createObjectURL(file);

  video.addEventListener("loadedmetadata", () => {
    validFiles.push({
      width: video.videoWidth,
      height: video.videoHeight,
      file,
      fileType: "video",
      duration: Math.round(video.duration),
    });
    resolve();
  });
};
